module.exports = __webpack_public_path__ + "img/Rodney Sullivan.23ff4c81.jpg";